import type { FaireProductEntity } from "../../entity_types/product";

export const p_vh9khkyckq: FaireProductEntity = {
  token: "p_vh9khkyckq",
  type: "product",
  name: "18K Gold Stainless Steel Herringbone Chain Necklace",
  brandToken: "b_99ch5ye698",
  brandName: "WJW",
  imageUrl:
    "https://cdn.faire.com/fastly/a43d9f1d0dccc2b2341337cb9ecbfdd7a60385c313f5f95f0e97b54ecb6b7ba7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/823b23fcb8af298a0f79d249a4f4af1c0654c496284e281b7b86566da1795a26.jpeg",
    "https://cdn.faire.com/fastly/197375da3225d566e7f161898197ffdd77ec53d6ce22af234b94a1ee45c53c29.jpeg",
    "https://cdn.faire.com/fastly/a9e2949b8d13ffc8ecb9db3fb79ffc78e4612f64989635232f2bd352efbd852f.jpeg",
    "https://cdn.faire.com/fastly/3207ca9d130674c8368a46786ad8e0f99480e2af28682ebe1b6be45cedcc3c5b.jpeg",
    "https://cdn.faire.com/fastly/14c36d388e1ac312051ba053edb6129dbfef70fdc8bf765318f74432f9ece9fc.jpeg",
    "https://cdn.faire.com/fastly/a72c668b5dc0b69319199e26c5e155c772627fc2ba3fbad876fccd4f144590f9.jpeg",
  ],
  priceDollars: 2.3,
  description:
    "A classic chain necklace for any holiday gift! The Gold Herringbone Chain Necklace is a stunning and elegant best-seller to keep in your necklace collection year-round for her. One of our best selling chains for a reason, the gold herringbone chain is a versatile necklace for women that can be worn alone or paired with other chains to achieve the perfect layered necklace look. Made with our proprietary blend of surgical-grade 18K Gold PVD coated stainless steel designed for everyday wear, your customers have quality, style, and comfort to cherish for years to come!\n\n• 100% Waterproof, Non-Tarnish, Hypoallergenic\n• 18K Gold PVD, 316L Stainless Steel\n• Comfortable all day wear\n• Secure lobster clasp closure\n\nWe use the process of PVD Coating our 18K Gold jewelry over 316L stainless steel for a non-tarnish, hypoallergenic, polished finish that will hold up best to everyday wear and will never turn your customer's skin green.\n\nApprox. Weight: 9-19 grams",
  tags: [],
  msrpDollars: 20.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:15.016Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
